import styled from 'styled-components';

export const RequestWrapper = styled.div`
  font-size: 14px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 0 3px 0 ${({ theme }) => theme.colors.shadowSilver};
  position: relative;

  .transparent-component {
    display: ${({ isTransparent }) => !isTransparent && 'none'};
    pointer-events: none;
    background-color: ${({ theme }) => theme.colors.white};;
    opacity: 0.5;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 10;
  }
 
  &:before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    display: block;
    width: 3px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    background-color: ${({ status }) => status.color};
  }

  .ant-collapse-content-active {
    overflow: visible;
  }
`;

export const DetailKey = styled.span`
  color: ${({ theme }) => theme.colors.secondaryDark};
  margin-right: 5px;
  text-transform: capitalize;
`;

export const DetailValue = styled.span`
  color: ${({ theme }) => theme.colors.mainDark};
  word-break: break-word;
  font-weight: 500;
`;



// WEBPACK FOOTER //
// ./src/components/requests-list-item/styled-components.js